import i18n from 'helpers/i18n';
import messages from './messages';

export function scoreToRange(score: number) {
  if (score >= 6) {
    return i18n.ft(messages.high);
  } else if (score >= 3) {
    return i18n.ft(messages.mid);
  } else {
    return i18n.ft(messages.low);
  }
}
